// extracted by mini-css-extract-plugin
export default {"buttonOutline":"ButtonOutline_buttonOutline__p1bVQ"};